module.exports = __webpack_public_path__ + "static/media/cabbage.3f67eca9.png";